import withAemIntegration from "../../../withAemIntegration";
import serviceParser, { dealerDataMap } from "../../../utils/serviceParser";

import loadable from "../../../utils/loadable";
const DividerLine = loadable(() =>
  import("@lexus.com/ui/dist/modules/DividerLine")
);
const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/GalleryComponent")
);

const DealerGalleryEditConfig = {
  emptyLabel: "DealerGallery",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const buildSlides = (slides) => {
  const newSlides = slides.map((slide) => {
    return {
      media: {
        image: {
          desktop: {
            id: "",
            type: "desktop",
            src: slide.dealerImageUrl,
            alt: "Desktop Image",
            width: "",
            height: "",
          },
        },
      },
    };
  });
  return newSlides;
};

const transformData = (props) => {
  return {
    heading: serviceParser(props.heading, dealerDataMap),
    textColor: props.textColor || "#000",
    slides: buildSlides(window.LEXUS.dealerData?.dealerOverlayImages || []),
  };
};

const DealerGallery = (props) => {
  const data = transformData(props);

  return window.LEXUS.dealerData?.dealerOverlayImages?.length > 0 ? (
    <>
      <Component {...data} />
      <DividerLine />
    </>
  ) : null;
};
export default withAemIntegration(
  "lexus/components/dealer-details/dealer-gallery"
)(DealerGallery, DealerGalleryEditConfig);
